module.exports = __webpack_public_path__ + "static/media/electrical_services.94d9ad76.svg";